import React, { Component } from "react";
import { nutrients } from "common/domain";
import * as utils from "common/utils";
import numeral from "numeral";
import Watermark from "components/Watermark";
import { compose, withState, withActions } from "containers/HOC";
import { setFormState } from "containers/App/_actions";
import ActionLink from "components/ActionLink";

const NutrientsLine = ({ fields, name, nutrientLine }) => {
    return (
        <tr className={`tr-nested`} id={utils.strToId(name)}>
            <td>{name}</td>
            {fields.map((n, index) => (
                <td key={index} className="u-textCenter" id={utils.strToId(`${name}_${n}`)}>
                    {nutrientLine && nutrientLine.nutrients && nutrientLine.nutrients[n] ? nutrientLine.nutrients[n] : 0}
                </td>
            ))}
        </tr>
    );
};

const NutrientTotalLine = ({ fields, name, nutrientLine, index, onClick, isShow, hasChildren, expandAll }) => {
    return (
        <tr id={utils.strToId(name)}>
            <td>
                {hasChildren && (
                    <ActionLink className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween" onClick={() => onClick(index)}>
                        {name}
                        {!expandAll && <i className={`icon icon-arrow-${isShow ? "up" : "down"}`}></i>}
                    </ActionLink>
                )}
                {!hasChildren && name}
            </td>
            {fields.map((n, index) => {
                const val = nutrientLine && nutrientLine.nutrients && nutrientLine.nutrients[n] ? nutrientLine.nutrients[n] : 0;
                return (
                    <td key={index} className="u-textCenter" id={utils.strToId(`${name}_${n}`)}>
                        {val}
                    </td>
                );
            })}
        </tr>
    );
};

const NutrientsSection = ({ nutrientBudget, effect, fields, headingClicked, showSections, categoryRefData, subCategoryRefData, expandAll, block }) => {
    const headingClick = (index) => {
        headingClicked(`${effect}_${index}`);
    };

    /*
0: {value: "Irrigation", text: "Irrigation"}
1: {value: "Fertiliser", text: "Fertiliser, lime and other"}
2: {value: "Spray", text: "Foliar sprays"}
3: {value: "AtmosphericAdded", text: "Rain/clover fixation"}
4: {value: "Supplements", text: "Supplements"}
5: {value: "Effluent", text: "Effluent added"}
6: {value: "Transfer", text: "Transfer"}
7: {value: "AtmosphericRemoved", text: "To atmosphere"}
8: {value: "Water", text: "From root zone"}
9: {value: "Product", text: "As product"}
10: {value: "EffluentExported", text: "Effluent exported"}
11: {value: "SupplementsAndResidues", text: "As supplements and crop residues"}
12: {value: "CropFrameWork", text: "Crop framework"}
13: {value: "InOrganic", text: "Inorganic mineral"}
14: {value: "Organic", text: "Organic pool"}
15: {value: "MineralResiduals", text: "Mineral residuals"}
16: {value: "PlantMaterial", text: "Plant material"}
17: {value: "InOrganicSoilPool", text: "Inorganic soil pool"}
*/
    //const blockTypeFilter = block ? blockTypeFilters.find(b=>b.blockTypes.includes(block.type)) : undefined
    //const fieldsToDisplay = blockTypeFilter ? blockTypeFilter.fields : undefined

    return Object.keys(nutrientBudget.nutrientCategories)
        .filter((c) => nutrientBudget.nutrientCategories[c] && nutrientBudget.nutrientCategories[c].total && nutrientBudget.nutrientCategories[c].effect === effect && (c === "Effluent" && effect === "Added" ? block !== undefined : true))
        .filter((c) => effect !== "Added" || block === undefined || block.type !== "ProductiveOutdoorPigs" || !["Effluent", "Fertiliser", "Irrigation"].includes(c))
        .map((c, index) => {
            const label = categoryRefData.find((r) => r.value === c) || { text: "Unknown" };
            var labelText = label.text;
            if (block !== undefined) {
                if (block.type === "ProductiveFruit" || block.type === "FodderCrop") {
                    if (label.value === "Supplements" && block.type === "ProductiveFruit") {
                        labelText = "Supplements for animals";
                    }
                    if (label.value === "InOrganicSoilPool") {
                        labelText = "Inorganic plant available";
                    }
                }
                if (block.type === "ProductivePasture") {
                    if (label.value === "Supplements") {
                        labelText = "Supplements fed on blocks";
                    }
                    // Cut  & Carry block only
                    if (block.animals && block.animals.length <= 0) {
                        if (label.value === "SupplementsAndResidues") {
                            labelText = "As Supplements";
                        }
                    }
                }
            }
            const subTotalKeys = Object.keys(nutrientBudget.nutrientCategories[c].subTotals);
            subTotalKeys.unshift("_total");
            const isShow = (showSections && showSections[`${effect}_${index}`]) || expandAll;
            return subTotalKeys
                .filter((s) => nutrientBudget.nutrientCategories[c].subTotals[s] || s === "_total")
                .map((s, j) => {
                    const subLabel = subCategoryRefData.find((r) => r.value === s) || { text: "Unknown" };
                    return s === "_total" ? <NutrientTotalLine key={labelText} fields={fields} name={labelText} nutrientLine={nutrientBudget.nutrientCategories[c].total} expandAll={expandAll} index={index} onClick={(id) => headingClick(id)} isShow={isShow} hasChildren={subTotalKeys.length > 1} /> : isShow ? <NutrientsLine key={subLabel.text} fields={fields} name={subLabel.text} nutrientLine={nutrientBudget.nutrientCategories[c].subTotals[s]} /> : null;
                });
        });
};

class NutrientBudget extends Component {
    constructor(props) {
        super(props);
        this.state = { showSections: {} };
    }

    headingClicked(id) {
        const { showSections = {} } = this.state;
        this.props.setFormState("nutrientBudget_expandAll", false);
        showSections[id] = !(showSections[id] || false);
        this.setState({ showSections: showSections });
    }

    selectBlock(e) {
        this.setState({ blockId: utils.ctrlVal(e) });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.expandAll && !this.props.expandAll && this.state.showSections) {
            this.setState({ showSections: undefined });
        }
    }

    render() {
        const { refData = {}, budget = {}, block, expandAll } = this.props;
        const results = block ? block.currentResults : budget.currentResults;
        const { nutrientBudget = {} } = results || {};

        return (
            <React.Fragment>
                {(!results || !results.nitrogenOverview || !results.phosphorusOverview) && "There are no nutrient results for this analysis. Please correct any errors shown for this analysis and try again."}

                <div className="FarmTable-supplementary">
                    {results && results.nitrogenOverview && results.phosphorusOverview && (
                        <React.Fragment>
                            <h5>Losses from root zone</h5>
                            <div className="Table Table-Compressed u-mt-sm">
                                <Watermark />
                                <table id="NutrientBudgetTotals">
                                    <thead>
                                        <tr>
                                            <th key={"nutrient-heading"}></th>
                                            <th key={"total-loss-heading"}>Total loss (kg/yr)</th>
                                            <th key={"loss-heading"}>Loss per ha (kg/yr)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Nitrogen</td>
                                            <td id="Nitrogen_totalLost">{numeral(results.nitrogenOverview.totalLost).format("0,0")}</td>
                                            <td id="Nitrogen_lostToWater">{results.nitrogenOverview.lostToWater}</td>
                                        </tr>
                                        <tr>
                                            <td>Phosphorus</td>
                                            <td id="Phosphorus_totalLost">{results.phosphorusOverview.totalLost}</td>
                                            <td id="Phosphorus_lostToWater">{results.phosphorusOverview.lostToWater}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </React.Fragment>
                    )}
                    {nutrientBudget && nutrientBudget.nutrientCategories && (
                        <div>
                            <div className="Table Table-Compressed u-mt-md">
                                <Watermark />
                                <table id="NutrientsAdded">
                                    <thead>
                                        <tr>
                                            <th key={"added-heading-name"} data-width="32.5">
                                                Nutrients added (kg/ha/yr)
                                            </th>
                                            {nutrients.map((f, index) => (
                                                <th key={index} className="u-textCenter" data-width="md-10 xl-10">
                                                    {f}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <NutrientsSection nutrientBudget={nutrientBudget} expandAll={expandAll} effect={"Added"} fields={nutrients} headingClicked={(id) => this.headingClicked(id)} showSections={this.state.showSections} categoryRefData={refData.nutrientBudgetCategoryTypes} subCategoryRefData={refData.nutrientResultsTypes} block={block} />
                                    </tbody>
                                </table>
                            </div>

                            <div className="Table Table-Compressed u-mt-md">
                                <Watermark />
                                <table id="NutrientsRemoved">
                                    <thead>
                                        <tr>
                                            <th key={"added-heading-name"} data-width="32.5">
                                                Nutrients removed (kg/ha/yr)
                                            </th>
                                            {nutrients.map((f, index) => (
                                                <th key={index} className="u-textCenter" data-width="md-10 xl-10">
                                                    {f}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <NutrientsSection nutrientBudget={nutrientBudget} expandAll={expandAll} effect={"Removed"} fields={nutrients} headingClicked={(id) => this.headingClicked(id)} showSections={this.state.showSections} categoryRefData={refData.nutrientBudgetCategoryTypes} subCategoryRefData={refData.nutrientResultsTypes} block={block} />
                                    </tbody>
                                </table>
                            </div>

                            <div className="Table Table-Compressed u-mt-md">
                                <Watermark />
                                <table id="ChangeInPools">
                                    <thead>
                                        <tr>
                                            <th key={"added-heading-name"} data-width="32.5">
                                                Change in pools (kg/ha/yr)
                                            </th>
                                            {nutrients.map((f, index) => (
                                                <th key={index} className="u-textCenter" data-width="md-10 xl-10">
                                                    {f}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <NutrientsSection nutrientBudget={nutrientBudget} expandAll={expandAll} effect={"ChangeInPools"} fields={nutrients} headingClicked={(id) => this.headingClicked(id)} showSections={this.state.showSections} categoryRefData={refData.nutrientBudgetCategoryTypes} subCategoryRefData={refData.nutrientResultsTypes} block={block} />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default compose(
    withState((state, ownProps) => {
        const { formState = {} } = state.app;
        const { nutrientBudget_expandAll = false } = formState;
        return {
            expandAll: nutrientBudget_expandAll,
        };
    }),
    withActions({ setFormState })
)(NutrientBudget);
